import { ApiCardType } from '@/core/generated/api';
import type { VoxServiceCardResponse } from '@/core/generated/api';
import type { ColumnConfig } from '@/shared/ui/DataTable/DataTable';

/** Колонки каталога карточек услуг */
export const VOX_SERVICE_COLUMNS: ColumnConfig<VoxServiceCardResponse>[] = [
    {
        field: 'index',
        header: 'Порядок'
    },
    {
        field: 'name',
        header: 'Карточка'
    },
    {
        field: 'productName',
        header: 'Продукт',
        body: item => item.productDeleted
            ? item.productName + ' (удалён)'
            : item.productName,
    },
    {
        field: 'cardType',
        header: 'Размер',
        body: item => item.cardType === ApiCardType.Big
            ? 'Большая'
            : 'Маленькая',
    },
    {
        field: 'isShowServices',
        header: 'В приложении',
        body: item => item.isShowServices
            ? 'Видна'
            : 'Скрыта',
    },
    {
        field: 'isUnderDevelopment',
        header: 'В разработке',
        body: item => item.isUnderDevelopment
            ? 'Да'
            : 'Нет',
    },
];

